import {useIntl} from 'react-intl'
import { Spinner } from 'react-bootstrap'

const MessageGenerating = ({text = ""}) => {
  const intl = useIntl()
  return (
    <>
      <span className="me-2">{text != "" ? text : intl.formatMessage({id: 'chat.message.generating'})}</span>
      <Spinner animation="border" variant="dark" size="sm" />
    </>
  )
}
export {MessageGenerating}
  